module.exports = __webpack_public_path__ + "img/home_pic_3.0_5.9fe90cff.webp";